module.exports = __webpack_public_path__ + "static/media/hospital.2b691318.jpg";